import { render } from "./CodeWidget.vue?vue&type=template&id=c63d0f7e&scoped=true"
import script from "./CodeWidget.vue?vue&type=script&lang=js"
export * from "./CodeWidget.vue?vue&type=script&lang=js"

import "./CodeWidget.vue?vue&type=style&index=0&id=c63d0f7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63d0f7e"],['__file',"src/components/CodeWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c63d0f7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c63d0f7e', __exports__)) {
    api.reload('c63d0f7e', __exports__)
  }
  
  module.hot.accept("./CodeWidget.vue?vue&type=template&id=c63d0f7e&scoped=true", () => {
    api.rerender('c63d0f7e', render)
  })

}


export default __exports__